// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3EJic","disabled":"FileBtn_disabled__2gO_i","warn":"FileBtn_warn__1vjbP","fade":"FileBtn_fade__2LmTT"};